import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router';
import { linkHandler } from 'utils/linkHandler';

const PrivateRoute = ({ component: Component, isAuthed, isGuest, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthed && !isGuest ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: linkHandler.get('login'),
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

PrivateRoute.propTypes = {
  isAuthed: PropTypes.bool.isRequired,
  isGuest: PropTypes.bool.isRequired,
  component: PropTypes.any.isRequired, //VoucherRouteContainer is switching to obj or function and self injection...but it's fixed the warning
  location: PropTypes.object
};

export default PrivateRoute;
